"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
exports.__esModule = true;
var react_1 = __importStar(require("react"));
var react_konva_1 = require("react-konva");
var UrlImg = function (_a) {
    var src = _a.src, x = _a.x, y = _a.y, width = _a.width, height = _a.height;
    var _b = (0, react_1.useState)(null), image = _b[0], setImage = _b[1];
    (0, react_1.useEffect)(function () {
        var loadImage = function () {
            var img = new window.Image();
            img.src = src;
            img.onload = function () { return setImage(img); };
        };
        loadImage();
        return function () {
            if (image) {
                image.removeEventListener("load", loadImage);
            }
        };
    }, [src]);
    if (!image)
        return react_1["default"].createElement(react_konva_1.Rect, { x: x, y: y, width: width, height: height });
    return react_1["default"].createElement(react_konva_1.Image, { x: x, y: y, width: width, height: height, image: image });
};
exports["default"] = UrlImg;
